module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic11.7dc3d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic11.png
// module id = 476
// module chunks = 1